import { AvailabilityCheckFields } from '@shared/generated/graphql';
import { SchedulePortalType } from 'clerk_common/enums';
import {
  OpendockAvailabilityInputFields,
  PortalTypeSpecificGetAvailabilityInputFields,
  ScheduleStop,
} from 'clerk_common/types';
import { OpendockFields } from './Opendock';

type CustomFieldsProps = {
  stop: ScheduleStop;
  fields: AvailabilityCheckFields;
  noTimes: boolean;
  handleFieldsChange: (
    i: PortalTypeSpecificGetAvailabilityInputFields
  ) => Promise<void>;
  setInputFields: (i: OpendockAvailabilityInputFields) => void;
};

export function CustomFields({
  stop,
  fields,
  handleFieldsChange,
  setInputFields,
  noTimes,
}: CustomFieldsProps) {
  const type = stop.placeSchedulePortalType;

  switch (type) {
    case SchedulePortalType.OPENDOCK:
      return (
        <OpendockFields
          fields={fields}
          stop={stop}
          handleFieldsChange={handleFieldsChange}
          setInputFields={setInputFields}
          noTimes={noTimes}
        />
      );
    default:
      return null;
  }
}
